// Feedback Assistant-style submissions, stored in the Firestore "feedback"
// collection (same "blinkbooks-marketing" project as access_codes).
import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { db } from "@/integrations/firebase/client";

const STORAGE_KEY = "bb_access";
const COLLECTION = "feedback";

export type FeedbackType = "bug" | "suggestion";

export interface FeedbackInput {
  title: string;
  area: string;
  type: FeedbackType;
  description: string;
  screen: string;
}

const getAccessCode = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? (JSON.parse(raw).code as string) : null;
  } catch {
    return null;
  }
};

export async function submitFeedback(input: FeedbackInput) {
  await addDoc(collection(db, COLLECTION), {
    ...input,
    accessCode: getAccessCode(),
    url: window.location.href,
    createdAt: serverTimestamp(),
  });
}
